import { configureStore } from '@reduxjs/toolkit';
import { reducer as form } from 'redux-form';

export const createStore = (debugEnabled) =>
  configureStore({
    reducer: { form },
    devTools: debugEnabled,
  });
